import { OptionCard, StepBody, StepHeader, StepNav } from "../Hikvision/HikvisionWizardParts";

// Used for both picking the cameras the output controls (per camera arming) and the live view cameras.
// selectedCameraIds holds Camect camera IDs.
// onEmptySkip / emptySkipLabel - optional, shown in place of Next when no cameras were returned
const WizardStepCamectCameraList = ({ title, subtitle, cameras, selectedCameraIds, setSelectedCameraIds, onNext, onBack, isLastStep, onEmptySkip, emptySkipLabel = "Skip" }) => {
    const showEmptySkip = cameras.length === 0 && onEmptySkip;
    console.log(cameras);
    const allSelected = cameras.length > 0 && cameras.every(camera => selectedCameraIds.includes(camera.id));

    const toggle = (id) => {
        setSelectedCameraIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    const toggleAll = () => {
        setSelectedCameraIds(allSelected ? [] : cameras.map(camera => camera.id));
    };

    return (
        <>
            <StepHeader title={title} subtitle={subtitle} />
            <StepBody>
                {cameras.length === 0 ? (
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <p style={{ color: "var(--text-label)", fontSize: "14px" }}>No cameras found.</p>
                        <p style={{ color: "#9e9e9e", fontSize: "12px" }}>If you recently changed the 'Camect integration type' you will need to unlink & relink the Camect</p>
                    </div>
                ) : (
                    <OptionCard title="Select all" selected={allSelected} onClick={toggleAll} />
                )}
                {cameras.map(camera => (
                    <OptionCard
                        key={camera.id}
                        title={camera.name}
                        selected={selectedCameraIds.includes(camera.id)}
                        onClick={() => toggle(camera.id)}
                    />
                ))}
            </StepBody>
            {showEmptySkip ? (
                <StepNav onBack={onBack} onNext={onEmptySkip} nextLabel={emptySkipLabel} nextIcon="pi pi-link" />
            ) : (
                <StepNav
                    onBack={onBack}
                    onNext={onNext}
                    nextDisabled={selectedCameraIds.length === 0}
                    nextLabel={isLastStep ? "Link Camect" : "Next"}
                    nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
                />
            )}
        </>
    );
};

export default WizardStepCamectCameraList;
